import { useEffect, useState } from 'react';

export type AppUserAgent = {
    isApp: boolean,
    os: 'ios' | 'android' | undefined,
    rawUserAgent: string
}

function readAppUserAgent(rawUserAgent: string): AppUserAgent {
    const isApp = rawUserAgent.includes('sunnyside');
    const os = (): 'ios' | undefined => {
        switch(true) {
        case rawUserAgent.toLowerCase().includes('iphone'):
            return 'ios';
        default: return undefined;
        }
    };
    return { isApp, os: os(), rawUserAgent };
}

/**
 * Cached for the page load so a navigation mounts already resolved. The state below is per component
 * instance, so without this every newly mounted consumer reported `undefined` for one render and
 * callers branching on it (see `useEmbeddedApp`) painted the wrong surface's chrome.
 *
 * Module scope rather than a lazy `useState` initializer, which is what keeps hydration safe: on the
 * first load this is still empty, so the hydrating render still matches the server's `undefined`.
 */
let resolvedUserAgent: AppUserAgent | undefined;

/* Used as a fallback for ss_app cookie; logic should be removed upon in-app diagnostic */
export default function useAppUserAgent(): AppUserAgent | undefined {
    const [userAgent, setUserAgent] = useState<AppUserAgent | undefined>(resolvedUserAgent);

    useEffect(() => {
        if (userAgent) {
            return;
        }
        resolvedUserAgent = readAppUserAgent(window.navigator.userAgent);
        setUserAgent(resolvedUserAgent);
    }, []);

    return userAgent;
}
